export enum EstateType {
  House = 'Villa',
  Cooperative = 'Bostadsrätt',
  RowHouse = 'Radhus',
  Cottage = 'Fritidshus',
  Agriculture = 'Gård',
  Plot = 'Tomt',
  Project = 'Nyproduktion',
  Commercial = 'Kommersiellt',
  OwnedApartment = 'Ägarlägenhet',
  Premises = 'Lokal',
}

export enum FilterTypes {
  AllEstates = 'allEstates',
  Area = 'area',
  Municipality = 'munici',
  County = 'county',
  EstateType = 'estateType',
  RangeTag = 'rangeTag',
  ExtraCritera = 'extraCriteria',
  Alignment = 'alignment',
  ShowSold = 'showSold',
  ShowOnlyHeadStart = 'showOnlyHeadStart',
  ShowGreenEstates = 'showGreenEstates',
  ShowBidding = 'showBidding',
  Broker = 'broker',
  Office = 'office',
  Polygons = 'polygons',
}
export enum StatusId {
  Empty = '2M0QLN0HN8D3RCHO',
  DuringIntake = '2HIII2GATHLRTMP9',
  ForSale = '2HIII41T24FNHOU2',
  Reserved = '2IV3QJ925HR9IFJM',
  Sold = '2HIII4T0O9LMQ3UI',
  Booked = '2Q92VBJ0M1E54PE4',
  Coming = '2O8JBQG8CAMFQQGC',
  UntilAdvertisement = '3IEABGRPJCRIS7V8',
  Repossessed = '2QGS54SRFUPE1S31',
  Quest = '40N3MK51AIO18SRP',
  LostIntake = '40N3NETL8IO18SRQ',
  FollowUp = '40N3O2RQUIO18SRR',
  Intake = '40SQ6IPLMADRPBV1',
  HeadStartHomes = '45D3RJETOQCL0BNL',
  SoonForSale = '4744HQQP4MPMUP0N',
  Valuation = '4CVJ143ID6UHMHQK',
  Other = '46SJUQ47D57AV478',
  AvailableForRent = '2IV3Q9RV3VFPNQCK',
  RentedProvisionally = '2IV3QI9HSHNGAL43',
  Rented = '2IV3QFG90LBGV1EE',
}

export enum RangeTagNames {
  Price = 'Pris',
  Room = 'Rum',
  LivingSpace = 'Boarea',
  Charge = 'Avgift',
  PlotArea = 'Tomtarea',
}

export enum EstateStatuses {
  Sold = 'Såld',
  ForSale = 'Till salu',
  Intake = 'Under intag',
  SoldOut = 'Slutsålt',
  Intaken = 'Intagen',
}

export enum ObjectListLayout {
  Row = 'row',
  Map = 'map',
  Grid = 'grid',
  ListLabel = 'Lista',
  MapLabel = 'Karta',
  BrokerLabel = 'Mäklare',
  OfficeLabel = 'Kontor',
  OfficeMap = 'officeMap',
  BrokerGrid = 'brokerGrid',
}

export enum FilterParams {
  MUNICI_PARAM = 'municipality',
  COUNTY_PARAM = 'county',
  AREA_PARAM = 'areaIds',
  EXTRACRITERIA_PARAM = 'extraSearch',
  ESTATETYPE_PARAM = 'estateType',
  ALIGNMENT_PARAM = 'alignment',
  PROPERTYTYPE_PARAM = 'propertyType',
  PRICEMIN_PARAM = 'priceMin',
  PRICEMAX_PARAM = 'priceMax',
  ROOMMIN_PARAM = 'roomsMin',
  ROOMMAX_PARAM = 'roomsMax',
  LIVINGSPACEMIN_PARAM = 'livingSpaceMin',
  LIVINGSPACEMAX_PARAM = 'livingSpaceMax',
  MONTHLYCOSTMIN_PARAM = 'monthlyCostMin',
  MONTHLYCOSTMAX_PARAM = 'monthlyCostMax',
  PLOTAREAMIN_PARAM = 'plotAreaMin',
  PLOTAREAMAX_PARAM = 'plotAreaMax',
  HEADSTART_PARAM = 'showOnlyHeadStart',
  SOLD_PARAM = 'showSold',
  GREENESTATES_PARAM = 'showGreenEstates',
  BROKERID_PARAM = 'brokerid',
  CUSTOMERID_PARAM = 'customerId',
  SORT_PARAM = 'sortOrder',
  BIDDING_PARAM = 'showBidding',
  POLYGON_PARAM = 'polygons',
}

export const SortType = [
  {
    id: '0',
    label: 'Visningsdatum',
  },
  {
    id: '1',
    label: 'Senast inkommet',
  },
  {
    id: '2',
    label: 'Pris stigande',
  },
  {
    id: '3',
    label: 'Pris fallande',
  },
  {
    id: '4',
    label: 'Boarea stigande',
  },
  {
    id: '5',
    label: 'Boarea fallande',
  },
  {
    id: '6',
    label: 'Antal rum stigande',
  },
  {
    id: '7',
    label: 'Antal rum fallande',
  },
  {
    id: '8',
    label: 'Tomtarea',
  },
];

export enum Status {
  forSale = 'Till salu',
  headStart = 'Kommande försäljning',
  headStartPlural = 'Kommande försäljningar',
  sold = 'Sålda bostäder',
}

export const FarmCriteriasDefault = [
  {
    id: 'Fritid',
  },
  {
    id: 'Skog',
  },
  {
    id: 'Hästgård',
  },
  {
    id: 'Spannmål',
  },
  {
    id: 'Kött',
  },
  {
    id: 'Svin',
  },
  {
    id: 'Mjölk',
  },
];

export const CommercialCriteriasDefault = [
  {
    id: 'Kontor',
  },
  {
    id: 'Bostäder',
  },
  {
    id: 'Butiker',
  },
  {
    id: 'Lager/logistik',
  },
  {
    id: 'Industri/verkstad',
  },
];

//BelongsTo is to select what estate type a criteria belongs to. This logic does not exist in vitec, therefore we've put it together here.
export type ExtraCriteria = {
  id: string;
  text: string;
  belongsTo: EstateType[];
};

export const ExtraCriterias: { [key: string]: ExtraCriteria } = {
  '0': {
    id: '0',
    text: 'Bastu',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
    ],
  },
  '1': {
    id: '1',
    text: 'Bottenplan',
    belongsTo: [EstateType.Cooperative, EstateType.OwnedApartment],
  },
  '2': {
    id: '2',
    text: 'Ej bottenplan',
    belongsTo: [EstateType.Cooperative, EstateType.OwnedApartment],
  },
  '23': {
    id: '23',
    text: 'Elbilsladdare',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.Agriculture,
      EstateType.Commercial,
      EstateType.Project,
      EstateType.Commercial,
    ],
  },
  '3': {
    id: '3',
    text: 'Eldstad',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
    ],
  },
  '4': {
    id: '4',
    text: 'Enplanshus',
    belongsTo: [EstateType.House, EstateType.Cottage],
  },
  '6': {
    id: '6',
    text: 'Etagelägenhet',
    belongsTo: [EstateType.Cooperative, EstateType.OwnedApartment],
  },
  '7': {
    id: '7',
    text: 'Exklusivt',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
      EstateType.Plot,
      EstateType.Commercial,
    ],
  },
  '8': {
    id: '8',
    text: 'Fri utsikt',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
      EstateType.Plot,
      EstateType.Commercial,
    ],
  },
  '9': {
    id: '9',
    text: 'Garage',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.Project,
      EstateType.Commercial,
      EstateType.Agriculture,
      EstateType.OwnedApartment,
    ],
  },
  '12': {
    id: '12',
    text: 'Havsutsikt',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
      EstateType.Plot,
      EstateType.Commercial,
    ],
  },
  '15': {
    id: '15',
    text: 'Högt läge',
    belongsTo: [EstateType.Cooperative, EstateType.OwnedApartment],
  },
  '14': {
    id: '14',
    text: 'Nära vatten',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.Project,
      EstateType.Plot,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
    ],
  },

  '25': {
    id: '25',
    text: 'Privat pool',
    belongsTo: [EstateType.House, EstateType.Cottage, EstateType.Agriculture],
  },
  '24': {
    id: '24',
    text: 'Solceller',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.Agriculture,
      EstateType.Project,
      EstateType.Commercial,
    ],
  },
  '13': {
    id: '13',
    text: 'Sjöutsikt',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
      EstateType.Plot,
      EstateType.Commercial,
    ],
  },
  '5': {
    id: '5',
    text: 'Takvåning',
    belongsTo: [EstateType.Cooperative, EstateType.OwnedApartment],
  },

  '16': {
    id: '16',
    text: 'Renoveringsobjekt',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
      EstateType.Commercial,
    ],
  },
  '22': {
    id: '22',
    text: 'Seniorboende',
    belongsTo: [
      EstateType.House,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
    ],
  },
  '17': {
    id: '17',
    text: 'Strandnära',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.Project,
      EstateType.Plot,
      EstateType.OwnedApartment,
      EstateType.Commercial,
    ],
  },
  '18': {
    id: '18',
    text: 'Takterass',
    belongsTo: [EstateType.Cooperative, EstateType.OwnedApartment],
  },
  '19': {
    id: '19',
    text: 'Trädgård',
    belongsTo: [
      EstateType.House,
      EstateType.Cottage,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
      EstateType.Agriculture,
      EstateType.Commercial,
    ],
  },
  '21': {
    id: '21',
    text: 'Uthyrningsdel',
    belongsTo: [
      EstateType.House,
      EstateType.Cooperative,
      EstateType.OwnedApartment,
    ],
  },
  '20': {
    id: '20',
    text: 'Vindsvåning',
    belongsTo: [EstateType.Cooperative, EstateType.OwnedApartment],
  },
};

export enum SelectedFilter {
  SearchProfileId = 'ProfileId',
  Area = 'selectedAreas',
  Municipality = 'selectedMunicips',
  EstateType = 'selectedEstateType',
  PriceMin = 'selectedPriceMin',
  PriceMax = 'selectedPriceMax',
  RoomMin = 'selectedRoomMin',
  RoomMax = 'selectedRoomMax',
  LivingMin = 'selectedLivingspaceMin',
  LivingMax = 'selectedLivingspaceMax',
  ChargeMin = 'selectedChargeMin',
  ChargeMax = 'selectedChargeMax',
  PlotMin = 'selectedPlotMin',
  PlotMax = 'selectedPlotMax',
  ExtraCrits = 'selectedExtraCrits',
  Polygons = 'selectedDrawnAreas',
}

export enum SpecialUnits {
  square = 'm²',
  cash = 'kr',
}

export enum ButtonStrings {
  saveAndContinue = 'Spara och fortsätt senare',
  doneAndSend = 'Klar! Skicka till mäklare',
  saveAssignments = 'Spara uppgifter',
  sendAllToBroker = 'Skicka alla uppgifter till min mäklare',
  sendNewChanges = 'Skicka nya ändringar till min mäklare',
  sendDocument = 'Skicka in dokument',
  yesImSure = 'Ja, jag är säker',
  noTakeMeBack = 'Nej, ta mig tillbaka',
  editSearchprofile = 'Redigera bevakning',
  removeSearchprofile = 'Ta bort bevakning',
  createNewSearchProfile = 'Skapa ny bevakning',
  goBack = 'Tillbaka',
  next = 'Nästa',
  seAllSpeculants = 'Se antal spekulanter',
  calculateAgain = 'Beräkna antal spekulanter igen',
  seeResult = 'Se resultat',
}

export enum BaseColorsBkg {
  Blue700 = 'bg-blue700',
  White = 'bg-white',
  Grey100 = 'bg-grey100',
}

export enum SpinnerColors {
  Blue700 = 'blue-spinner',
  Black500 = 'secondary-spinner',
  White = 'white-spinner',
}

export enum BrokerLoginErrors {
  ContactNotFoundInVitec = 'ContactNotFoundInVitec',
  TokenExpiredOrEmpty = 'TokenExpiredOrEmpty',
  UserNotFoundInMyPages = 'UserNotFoundInMyPages',
  WrongEntryWay = 'WrongEntryWay',
}
export enum SearchProfile {
  SearchProfileHeadline = 'Bevaka sökning',
  NoParams = 'För att spara en bevakning måste du ha valt några sökparametrar.',
  SearchSummary = 'Sammanfattning av sökning',
  FillInformation = 'Ange dina uppgifter',
  ErrorBroker = 'Tyvärr kan du inte bevaka en mäklare eller ett kontors aktuella bostäder. Försök hitta andra lämpliga sökalternativ.',
  ErrorNotAllParams = 'För att skapa en bevakning behöver du välja en <strong>kommun, område (ej län) eller rita ut ett område</strong>, samt en <strong>bostadstyp</strong>.',
  SeveralError = 'Tyvärr kan du inte bevaka flera objekttyper samtidigt.  Behåll en objekttyp för att skapa bevakning.',
  CountyError = 'Tyvärr kan du inte bevaka bostäder i ett län. Försök igen med kommun.',
  FarmPlotError = 'Tomtarea är tyvärr inte applicerbart på gård.',
  ForbiddenTypesError = 'Tyvärr kan du inte skapa en bevakning på <strong>nyproduktion</strong> och <strong>kommersiellt</strong>.',
  IntroText = 'Här skapar du bevakningen så att du garanterat inte missar den dag då ditt drömboende dyker upp. Ange dina uppgifter här så mailar vi dig när matchande bostäder dyker upp!',
  SavedSearchProfile = 'Din bevakning är sparad!',
  GoToMyPages = 'Gå till mina sidor',
  MyPagesTextLoggedIn = 'Du kommer framöver få mail med intressanta bostäder baserat på din bevakning. Vill du själv redigera dina bevakningar och följa upp dem här på hemsidan går du till',
  MyPagesText = 'Du kommer framöver få mail med intressanta bostäder baserat på din bevakning. Vill du själv redigera dina bevakningar och följa upp dem här på hemsidan behöver du skapa ett konto eller logga in på mina sidor.',
  AutoGenerated = 'Autogenererad',
}
export enum Estates {
  GreenEstate = 'Hållbart val',
  LDPlus = 'Försäkrad Plus',
  SearchEstate = 'Sök bostad',
  SearchPlaceholder = 'Sök på kommun, område eller adress',
  CreateSearchProfile = 'Skapa bevakning',
}
export enum ObjectPage {
  HeliView = 'Helikoptervy',
  ThreeDView = '3D Visning',
  Document = 'Dokument',
}
export enum MyPagesObject {
  SendDocumentText = 'Här kan du ladda upp och skicka dokument till din mäklare. Det skulle t.ex. kunna vara ett bygglov eller årsredovisning.',
  SendDocumentHeadline = 'Skicka dokument',
}
export enum Common {
  Back = 'Tillbaka',
  Close = 'Stäng',
}

export type SearchCriteria = {
  municipality: string;
  area: string;
  county: string;
  estateType: string;
  priceMin: number;
  priceMax: number;
  monthlyCostMin: number;
  monthlyCostMax: number;
  roomsMin: number;
  roomsMax: number;
  livingSpaceMin: number;
  livingSpaceMax: number;
  showSoldEstates: boolean;
  showOnlyHeadStart: boolean;
  extraSearch: string;
  alignment: string;
  plotAreaMin: number;
  plotAreaMax: number;
  customerId: string;
  brokerId: string;
  showGreenEstates: boolean;
  showBidding: boolean;
  drawnAreas: string;
  sortOrder: number;
};
export enum ServicesTitles {
  GreenEstate = 'Bra energiklass',
  HeadStart = 'Kommande försäljning',
  LD = 'Försäkrad Plus',
}

export enum SpeculationCheckStrings {
  EnterSquaremeters = 'Ange kvadratmeter',
  EnterRoomsExKitchen = 'Ange rum, exklusive kök',
  EnterMonthlyFee = 'Ange månadskostnad',
  EnterSum = 'Ange belopp',
}

export enum SpeculationCheckTypes {
  EstateType = 'Bostadstyp',
  Address = 'Adress',
  LivingArea = 'Boarea',
  Rooms = 'Rum',
  MonthlyFee = 'Månadsavgift',
  PlotArea = 'Tomtarea',
  SellPrice = 'Försäljningspris',
  Message = 'Meddelande',
}
export enum KycServiceNames {
  Kyc = 'Kundkännedom',
  KycBuyer = 'Kundkännedom köpare',
  KycSeller = 'Kundkännedom säljare',
}

export enum ConsentEnums {
  Approved = 'Approved',
  Declined = 'Declined',
  Revoked = 'Revoked',
  Dismissed = 'Dismissed',
  Faulted = 'Faulted',
  ApprovedLabel = 'Godkänt',
  DeclinedLabel = 'Nekat',
  RevokedLabel = 'Återkallat',
  FaultedLabel = 'Ej tillgängligt',
  NoAnswerLabel = 'Obesvarat',
  ApproveLabel = 'Ja, jag samtycker',
  DeclineLabel = 'Nej, inte just nu',
  RevokeLabel = 'Återkalla ditt samtycke',
  GetConsentError = 'Hämtningen utav samtyckes uppgifter misslyckades, testa igen senare eller kontakta support.',
  HandleConsentError = 'Något gick fel vid hanteringen utav samtycket. Vänligen försök igen eller kontakta support.',
  DismissedKey = 'consentModalDismissed',
  FaultedError = 'Något har gått fel kopplat till samtycket, vi jobbar på det.',
}
